import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import WarningIcon from "@material-ui/icons/Warning";
import Button from "@material-ui/core/Button";

import api from "../../services/api";
import SubscriptionModal from "../../components/SubscriptionModal";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
	root: {
		height: "100vh",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		gap: theme.spacing(2),
		padding: theme.spacing(3),
		textAlign: "center",
	},
}));

const FinanceiroAberto = () => {
	const classes = useStyles();
	const history = useHistory();
	const { handleLogout } = useContext(AuthContext);
	const [loading, setLoading] = useState(true);
	const [invoice, setInvoice] = useState(null);

	useEffect(() => {
		const load = async () => {
			try {
				const { data } = await api.get("/invoices/all");
				const invoices = Array.isArray(data) ? data : [];

				const hoje = new Date();
				hoje.setHours(0, 0, 0, 0);

				const pendente = invoices.find((inv) => {
					if (inv.status === "paid") return false;
					const venc = new Date(inv.dueDate);
					venc.setHours(0, 0, 0, 0);
					return venc <= hoje;
				});

				if (!pendente) {
					history.push("/tickets");
					return;
				}

				setInvoice(pendente);
			} catch (_) {
				// se der erro na consulta, não deixa o usuário travado sem saída
			}
			setLoading(false);
		};

		load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (loading) {
		return (
			<div className={classes.root}>
				<CircularProgress />
			</div>
		);
	}

	return (
		<div className={classes.root}>
			<WarningIcon style={{ fontSize: 56 }} color="error" />
			<Typography variant="h5">Assinatura vencida</Typography>
			<Typography variant="body1" color="textSecondary">
				Efetue o pagamento abaixo para liberar o acesso ao sistema.
			</Typography>
			<Button onClick={handleLogout}>Sair</Button>

			{invoice && (
				<SubscriptionModal open onClose={() => {}} Invoice={invoice} />
			)}
		</div>
	);
};

export default FinanceiroAberto;
